/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import {
    CashBoxTimeDeltaHistoryDto,
    CashBoxTimeDeltaHistoryQueryParams,
} from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';
import { PeriodQueryParams } from '../../../api/apiCommon.typings';

export enum CashBoxTimeDeltaTabActionType {
    EXIT_CASHBOX_TIME_DELTA_TAB = 'CashBoxTimeDeltaTab/ exit tab',
    FETCH_CASHBOX_TIME_DELTA_HISTORY = 'CashBoxTimeDeltaTab/ fetch time delta history start',
    FETCH_CASHBOX_TIME_DELTA_HISTORY_SUCCESS = 'CashBoxTimeDeltaTab/ fetch time delta history success',
    FETCH_CASHBOX_TIME_DELTA_HISTORY_ERROR = 'CashBoxStateTab/ fetch time delta history error',
    DOWNLOAD_TIME_DELTA_HISTORY = 'CashBoxTimeDeltaTab/ download time delta history as excel start',
    DOWNLOAD_TIME_DELTA_HISTORY_SUCCESS = 'CashBoxTimeDeltaTab/ download time delta history as excel success',
    DOWNLOAD_TIME_DELTA_HISTORY_ERROR = 'CashBoxTimeDeltaTab/ download time delta history as excel error',
}

export const exitCashBoxTimeDeltaTabAction = () =>
    createAction(CashBoxTimeDeltaTabActionType.EXIT_CASHBOX_TIME_DELTA_TAB);

export const fetchCashBoxTimeDeltaHistoryAction = (params: CashBoxTimeDeltaHistoryQueryParams) =>
    createAction(CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY, params);

export const fetchCashBoxTimeDeltaHistorySuccessAction = (payload: CashBoxTimeDeltaHistoryDto) =>
    createAction(CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY_SUCCESS, payload);

export const fetchCashBoxTimeDeltaHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY_ERROR, { notification });

export const downloadTimeDeltaHistoryAction = (params: PeriodQueryParams) =>
    createAction(CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY, params);

export const downloadTimeDeltaHistorySuccessAction = () =>
    createAction(CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY_SUCCESS);

export const downloadTimeDeltaHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY_ERROR, { notification });

export type CashBoxTimeDeltaTabAction =
    | ReturnType<typeof exitCashBoxTimeDeltaTabAction>
    | ReturnType<typeof fetchCashBoxTimeDeltaHistoryAction>
    | ReturnType<typeof fetchCashBoxTimeDeltaHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxTimeDeltaHistoryErrorAction>
    | ReturnType<typeof downloadTimeDeltaHistoryAction>
    | ReturnType<typeof downloadTimeDeltaHistorySuccessAction>
    | ReturnType<typeof downloadTimeDeltaHistoryErrorAction>;
